import type { Components, Theme } from '@mui/material/styles';

export default function MuiRadio(theme: Theme): Components['MuiRadio'] {
  return {
    styleOverrides: {
      root: {
        '&.Mui-checked': {
          color: theme.palette.taiga.main,
        },
      },
    },
  };
}
